import * as React from 'react';
import { StackLayout, UtilityText } from '@leagueplatform/genesis-core';
import { CopyButton } from '../copy-button/copy-button.component';

interface ValueWIthCopyButtonProps {
  value: string;
  buttonLabel: string;
  hideText?: boolean;
}

export const ValueWithCopyButton = ({
  value,
  buttonLabel,
  hideText = false,
}: ValueWIthCopyButtonProps) => (
  <StackLayout
    orientation="horizontal"
    verticalAlignment="center"
    spacing="$half"
    horizontalAlignment="spaceBetween"
  >
    {!hideText && (
      <UtilityText
        data-testid={`${buttonLabel}-text`}
        emphasis="subtle"
        size="sm"
        css={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </UtilityText>
    )}
    <CopyButton
      label={buttonLabel}
      priority="tertiary"
      contents={value}
      hideLabel
    />
  </StackLayout>
);
